var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('pre',[_c('b',[_vm._v("ERROR")]),_c('br'),_vm._v(_vm._s(_vm.error))]):(! _vm.ready)?_c('pre',{staticClass:"loading",staticStyle:{"color":"white","position":"absolute","left":"50%","top":"50%","-webkit-transform":"translate(-50%, -50%)","transform":"translate(-50%, -50%)"}},[_vm._v("Loading...")]):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }